import { makeStyles } from 'tss-react/mui';

import { dFlex } from '@assets/mixins';

const useStyles = makeStyles()(() => ({
  link: {
    ...dFlex('unset', 'center'),
    gap: '8px',
    '&:hover': {
      opacity: 0.8,
    },
  },
}));

export default useStyles;
